import React from 'react';
import { Button } from 'antd';
import styles from './COIconButton.module.scss';
import { ButtonSize, ButtonType } from 'enums/ButtonEnums';
import clsx from 'clsx';

export interface COIconButtonProps {
  children?: React.ReactNode;
  onClick?: React.MouseEventHandler<HTMLElement>;
  color?: string;
  size?: ButtonSize.LARGE | ButtonSize.MEDIUM | ButtonSize.SMALL;
  disabled?: boolean;
  icon: React.ReactNode;
  primary?: boolean;
  secondary?: boolean;
  text?: boolean;
}
const secondaryIconClass = clsx({
  [styles.iconBtn]: true,
  [styles.iconBtnSecondary]: true,
});
const TextIconClass = clsx({
  [styles.iconBtn]: true,
  [styles.iconText]: true,
});
const COIconButton = ({
  primary,
  secondary,
  text,
  onClick,
  size,
  disabled,
  icon,
}: COIconButtonProps) => {
  const currentType = text
    ? ButtonType.TEXT
    : secondary
    ? ButtonType.DEFAULT
    : primary
    ? ButtonType.PRIMARY
    : ButtonType.PRIMARY;
  return (
    <div className={styles.container}>
      {secondary ? (
        <Button
          onClick={onClick}
          type={currentType}
          className={secondaryIconClass}
          size={size ? size : ButtonSize.LARGE}
          disabled={!!disabled}>
          {icon}
        </Button>
      ) : (
        <Button
          onClick={onClick}
          type={currentType}
          className={TextIconClass}
          size={size ? size : ButtonSize.LARGE}
          disabled={!!disabled}>
          {icon}
        </Button>
      )}
    </div>
  );
};
export default COIconButton;
